import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const agentKPIApi = createApi({
  reducerPath: "agentKPIApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["AgentKPI", "KPIStats"],
  endpoints: (builder) => ({
    // Get all KPIs
    getAllKPIs: builder.query({
      query: (params) => ({
        url: "/agent-kpi",
        params,
      }),
      transformResponse: (response) => response.data || { kpis: [] },
      providesTags: ["AgentKPI"],
    }),

    // Get KPI dashboard stats
    getKPIDashboard: builder.query({
      query: (params) => ({
        url: "/agent-kpi/dashboard",
        params,
      }),
      transformResponse: (response) => response.data || { totals: {}, conversionRates: {}, daysTracked: 0 },
      providesTags: ["KPIStats"],
    }),

    // Get KPI by period
    getKPIByPeriod: builder.query({
      query: ({ period, startDate, endDate }) => ({
        url: "/agent-kpi/period",
        params: { period, startDate, endDate },
      }),
      transformResponse: (response) => response.data || { kpis: [] },
      providesTags: ["AgentKPI"],
    }),

    // Get single KPI entry
    getKPIById: builder.query({
      query: (id) => `/agent-kpi/${id}`,
      transformResponse: (response) => response.data?.kpi || null,
      providesTags: (result, error, id) => [{ type: "AgentKPI", id }],
    }),

    // Create KPI entry
    createKPI: builder.mutation({
      query: (data) => ({
        url: "/agent-kpi",
        method: "POST",
        body: data,
      }),
      transformResponse: (response) => response.data?.kpi || response,
      invalidatesTags: ["AgentKPI", "KPIStats"],
    }),

    // Update KPI entry
    updateKPI: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/agent-kpi/${id}`,
        method: "PUT",
        body: data,
      }),
      transformResponse: (response) => response.data?.kpi || response,
      invalidatesTags: (result, error, { id }) => [
        { type: "AgentKPI", id },
        "AgentKPI",
        "KPIStats",
      ],
    }),

    // Log activity (increment KPI)
    logKPIActivity: builder.mutation({
      query: (data) => ({
        url: "/agent-kpi/log-activity",
        method: "POST",
        body: data,
      }),
      transformResponse: (response) => response.data?.kpi || response,
      invalidatesTags: ["AgentKPI", "KPIStats"],
    }),

    // Delete KPI entry
    deleteKPI: builder.mutation({
      query: (id) => ({
        url: `/agent-kpi/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["AgentKPI", "KPIStats"],
    }),
  }),
});

export const {
  useGetAllKPIsQuery,
  useGetKPIDashboardQuery,
  useGetKPIByPeriodQuery,
  useGetKPIByIdQuery,
  useCreateKPIMutation,
  useUpdateKPIMutation,
  useLogKPIActivityMutation,
  useDeleteKPIMutation,
} = agentKPIApi;
